/**
 * MOSKERA Configurator — core runtime (perf, state, validation)
 * Loaded by sections/moskera-configurator.liquid
 */
(function (global) {
  "use strict";

  var MKC = global.MKC || {};

  /* ---- Scheduler: rAF batch + debounce ---- */
  var rafPending = false;
  var debounceTimers = {};

  MKC.schedule = function (fn) {
    if (typeof fn !== "function") return;
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      fn();
    });
  };

  MKC.debounce = function (key, fn, ms) {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(fn, ms == null ? 100 : ms);
  };

  /* ---- Dimension limits (cm) aligned with pricing tiers ---- */
  MKC.DIM_LIMITS = {
    porte: { min: 30, maxW: 250, maxH: 250 },
    fenetre: { min: 30, maxW: 250, maxH: 250 },
    grande: { min: 50, maxW: 320, maxH: 340 },
    velux: { min: 30, maxW: 160, maxH: 200 },
    autre: { min: 30, maxW: 320, maxH: 340 },
  };

  MKC.validationI18n = {
    fr: {
      min: "Minimum {{min}} cm.",
      maxW: "Largeur max. {{max}} cm pour ce modèle.",
      maxH: "Hauteur max. {{max}} cm pour ce modèle.",
      arch: "Hauteur 2 doit être inférieure à Hauteur 1.",
      asym: "Les hauteurs/largeurs doivent être positives.",
    },
    en: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. width {{max}} cm for this model.",
      maxH: "Max. height {{max}} cm for this model.",
      arch: "Height 2 must be less than Height 1.",
      asym: "Heights/widths must be positive.",
    },
    de: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. Breite {{max}} cm für dieses Modell.",
      maxH: "Max. Höhe {{max}} cm für dieses Modell.",
      arch: "Höhe 2 muss kleiner als Höhe 1 sein.",
      asym: "Höhen/Breiten müssen positiv sein.",
    },
    es: {
      min: "Mínimo {{min}} cm.",
      maxW: "Anchura máx. {{max}} cm para este modelo.",
      maxH: "Altura máx. {{max}} cm para este modelo.",
      arch: "Altura 2 debe ser inferior a Altura 1.",
      asym: "Las alturas/anchuras deben ser positivas.",
    },
    it: {
      min: "Minimo {{min}} cm.",
      maxW: "Larghezza max. {{max}} cm per questo modello.",
      maxH: "Altezza max. {{max}} cm per questo modello.",
      arch: "Altezza 2 deve essere inferiore ad Altezza 1.",
      asym: "Altezze/larghezze devono essere positive.",
    },
    nl: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. breedte {{max}} cm voor dit model.",
      maxH: "Max. hoogte {{max}} cm voor dit model.",
      arch: "Hoogte 2 moet kleiner zijn dan Hoogte 1.",
      asym: "Hoogtes/breedtes moeten positief zijn.",
    },
    pt: {
      min: "Mínimo {{min}} cm.",
      maxW: "Largura máx. {{max}} cm para este modelo.",
      maxH: "Altura máx. {{max}} cm para este modelo.",
      arch: "Altura 2 deve ser inferior à Altura 1.",
      asym: "Alturas/larguras devem ser positivas.",
    },
    pl: {
      min: "Minimum {{min}} cm.",
      maxW: "Maks. szerokość {{max}} cm dla tego modelu.",
      maxH: "Maks. wysokość {{max}} cm dla tego modelu.",
      arch: "Wysokość 2 musi być mniejsza niż Wysokość 1.",
      asym: "Wysokości/szerokości muszą być dodatnie.",
    },
    sv: {
      min: "Minimum {{min}} cm.",
      maxW: "Max bredd {{max}} cm för denna modell.",
      maxH: "Max höjd {{max}} cm för denna modell.",
      arch: "Höjd 2 måste vara mindre än Höjd 1.",
      asym: "Höjder/bredder måste vara positiva.",
    },
    da: {
      min: "Minimum {{min}} cm.",
      maxW: "Maks. bredde {{max}} cm for denne model.",
      maxH: "Maks. højde {{max}} cm for denne model.",
      arch: "Højde 2 skal være mindre end Højde 1.",
      asym: "Højder/bredder skal være positive.",
    },
    no: {
      min: "Minimum {{min}} cm.",
      maxW: "Maks. bredde {{max}} cm for denne modellen.",
      maxH: "Maks. høyde {{max}} cm for denne modellen.",
      arch: "Høyde 2 må være mindre enn Høyde 1.",
      asym: "Høyder/bredder må være positive.",
    },
    fi: {
      min: "Vähintään {{min}} cm.",
      maxW: "Enimmäisleveys {{max}} cm tälle mallille.",
      maxH: "Enimmäiskorkeus {{max}} cm tälle mallille.",
      arch: "Korkeus 2 on oltava pienempi kuin Korkeus 1.",
      asym: "Korkeuksien/leveyksien on oltava positiivisia.",
    },
    cs: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. šířka {{max}} cm pro tento model.",
      maxH: "Max. výška {{max}} cm pro tento model.",
      arch: "Výška 2 musí být menší než Výška 1.",
      asym: "Výšky/šířky musí být kladné.",
    },
    sk: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. šírka {{max}} cm pre tento model.",
      maxH: "Max. výška {{max}} cm pre tento model.",
      arch: "Výška 2 musí byť menšia ako Výška 1.",
      asym: "Výšky/šírky musia byť kladné.",
    },
    sl: {
      min: "Najmanj {{min}} cm.",
      maxW: "Največja širina {{max}} cm za ta model.",
      maxH: "Največja višina {{max}} cm za ta model.",
      arch: "Višina 2 mora biti manjša od Višine 1.",
      asym: "Višine/širine morajo biti pozitivne.",
    },
    hr: {
      min: "Minimum {{min}} cm.",
      maxW: "Maks. širina {{max}} cm za ovaj model.",
      maxH: "Maks. visina {{max}} cm za ovaj model.",
      arch: "Visina 2 mora biti manja od Visine 1.",
      asym: "Visine/širine moraju biti pozitivne.",
    },
    hu: {
      min: "Minimum {{min}} cm.",
      maxW: "Max. szélesség {{max}} cm ehhez a modellhez.",
      maxH: "Max. magasság {{max}} cm ehhez a modellhez.",
      arch: "Magasság 2 kisebb kell legyen, mint Magasság 1.",
      asym: "A magasságok/szélességek pozitívak legyenek.",
    },
    el: {
      min: "Ελάχιστο {{min}} cm.",
      maxW: "Μέγ. πλάτος {{max}} cm για αυτό το μοντέλο.",
      maxH: "Μέγ. ύψος {{max}} cm για αυτό το μοντέλο.",
      arch: "Το Ύψος 2 πρέπει να είναι μικρότερο από το Ύψος 1.",
      asym: "Τα ύψη/πλάτη πρέπει να είναι θετικά.",
    },
    ja: {
      min: "最小 {{min}} cm。",
      maxW: "このモデルの最大幅は {{max}} cm です。",
      maxH: "このモデルの最大高さは {{max}} cm です。",
      arch: "高さ2は高さ1より小さくしてください。",
      asym: "高さ・幅は正の値で入力してください。"
    },
    ar: {
      min: "الحد الأدنى {{min}} سم.",
      maxW: "أقصى عرض {{max}} سم لهذا الطراز.",
      maxH: "أقصى ارتفاع {{max}} سم لهذا الطراز.",
      arch: "يجب أن يكون الارتفاع 2 أقل من الارتفاع 1.",
      asym: "يجب أن تكون الأبعاد موجبة.",
    },
    he: {
      min: 'מינימום {{min}} ס"מ.',
      maxW: 'רוחב מקסימלי {{max}} ס"מ לדגם זה.',
      maxH: 'גובה מקסימלי {{max}} ס"מ לדגם זה.',
      arch: "גובה 2 חייב להיות קטן מגובה 1.",
      asym: "גובה/רוחב חייבים להיות חיוביים.",
    },
  };

  /* ---- Message "champs requis" (blocage ajout panier) ---- */
  MKC.reqMsgs = {
    fr: "Veuillez remplir toutes les dimensions requises.",
    en: "Please fill in all the required dimensions.",
    de: "Bitte geben Sie alle erforderlichen Maße an.",
    es: "Rellene todas las dimensiones requeridas.",
    it: "Compila tutte le dimensioni richieste.",
    nl: "Vul alle vereiste afmetingen in.",
    pt: "Preencha todas as dimensões obrigatórias.",
    pl: "Podaj wszystkie wymagane wymiary.",
    sv: "Fyll i alla obligatoriska mått.",
    da: "Udfyld alle påkrævede mål.",
    no: "Fyll inn alle nødvendige mål.",
    fi: "Täytä kaikki vaaditut mitat.",
    cs: "Vyplňte všechny požadované rozměry.",
    sk: "Vyplňte všetky požadované rozmery.",
    sl: "Izpolnite vse zahtevane mere.",
    hr: "Ispunite sve potrebne dimenzije.",
    hu: "Adja meg az összes szükséges méretet.", ro: "Indisponibil pentru forma rotundă",
    el: "Συμπληρώστε όλες τις απαιτούμενες διαστάσεις.",
    ja: "必要な寸法をすべて入力してください。",
    ar: "يرجى ملء جميع الأبعاد المطلوبة.",
    he: "אנא מלאו את כל המידות הנדרשות.",
  };

  MKC.reqMsg = function () {
    return MKC.reqMsgs[MKC.locale()] || MKC.reqMsgs.en;
  };

  MKC.locale = function () {
    var c = (
      (global.Shopify && global.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      "en"
    )
      .toLowerCase()
      .slice(0, 2);
    if (c === "nb" || c === "nn") c = "no";
    return c;
  };

  MKC.vMsg = function (key, vars) {
    var dict = MKC.validationI18n[MKC.locale()] || MKC.validationI18n.en;
    var tpl = dict[key] || MKC.validationI18n.en[key] || "";
    var out = tpl.replace(/\{\{(\w+)\}\}/g, function (_, k) {
      return vars[k] != null ? vars[k] : "";
    });
    /* marché US : les bornes s'affichent en pouces (voir mode impérial plus bas) */
    return window.MKcv ? window.MKcv(out) : out;
  };

  MKC.tpl = function (tpl, vars) {
    return tpl.replace(/\{\{(\w+)\}\}/g, function (_, k) {
      return vars[k] != null ? vars[k] : "";
    });
  };

  /* ---- Shared state ---- */
  MKC.state = MKC.state || { lines: [], detail: "", dimsValid: false };

  MKC.getRoot = function () {
    return document.querySelector("[data-mkc]");
  };

  MKC.q = function (sel, ctx) {
    var r = ctx || MKC.getRoot();
    return r ? r.querySelector(sel) : null;
  };

  MKC.qa = function (sel, ctx) {
    var r = ctx || MKC.getRoot();
    return r ? Array.prototype.slice.call(r.querySelectorAll(sel)) : [];
  };

  MKC.val = function (name) {
    var r = MKC.getRoot();
    if (!r) return "";
    var el =
      r.querySelector('[name="' + name + '"]:checked') ||
      r.querySelector('[name="' + name + '"]');
    return el ? el.value : "";
  };

  MKC.num = function (name) {
    var r = MKC.getRoot();
    if (!r) return 0;
    var el = r.querySelector('[name="' + name + '"]');
    return el ? parseFloat(el.value) || 0 : 0;
  };

  MKC.currentModel = function () {
    var r = MKC.getRoot();
    if (!r) return "";
    var sel = r.querySelector('[data-group="application"] .is-sel');
    return sel ? sel.getAttribute("data-model") : "";
  };

  MKC.appKey = function () {
    var v = MKC.val("application");
    if (v.indexOf("Porte") === 0) return "porte";
    if (v.indexOf("Fen") === 0) return "fenetre";
    if (v === "Velux") return "velux";
    if (v.indexOf("Baie") === 0 || v.indexOf("Pergola") === 0) return "grande";
    return "autre";
  };

  MKC.validateDimensions = function () {
    var model = MKC.currentModel() || MKC.appKey() || "autre";
    var lim = MKC.DIM_LIMITS[model] || MKC.DIM_LIMITS.autre;
    var forme = MKC.val("forme");
    var w = MKC.num("width");
    var h = MKC.num("height");
    var h2 = MKC.num("hauteur_2");
    var l2 = MKC.num("largeur_2");
    var seg = MKC.num("segments");
    var msgs = [];
    var fields = [];

    // Circulaire : seule la case Diamètre (saisie dans "width") est demandée ; la hauteur suit le diamètre.
    if (forme === "Circulaire") {
      if (!w) {
        return { ok: false, empty: true, messages: [], fields: [] };
      }
      h = w;
    } else if (!w || !h) {
      // État initial (rien saisi) : panier désactivé, sans message intrusif.
      return { ok: false, empty: true, messages: [], fields: [] };
    }

    // ---- Champs OBLIGATOIRES par forme : bloquent l'ajout au panier avec message ----
    if (forme === "Cintré" && !(h2 > 0)) {
      // Cintré : Largeur + Hauteur 1 + Hauteur 2 impératives.
      msgs.push(MKC.reqMsg());
      fields.push("hauteur_2");
    }
    if (forme === "Asymétrique" && !(l2 > 0 || h2 > 0)) {
      // Asymétrique : min. 3 cases sur 4 = Largeur 1 + Hauteur 1 + (Largeur 2 OU Hauteur 2).
      msgs.push(MKC.reqMsg());
      fields.push("largeur_2", "hauteur_2");
    }
    if (forme === "Hexagonal" && !(seg >= 3)) {
      // Hexagonal : Largeur + Hauteur + nombre de côtés (≥ 3).
      msgs.push(MKC.reqMsg());
      fields.push("segments");
    }

    if (w < lim.min) {
      msgs.push(MKC.vMsg("min", { min: lim.min }));
      fields.push("width");
    }
    if (h < lim.min) {
      msgs.push(MKC.vMsg("min", { min: lim.min }));
      fields.push(forme === "Circulaire" ? "width" : "height");
    }
    // Aucune limite de dimension maximale : production sur-mesure jusqu'à plusieurs mètres.
    // (La règle porte > 300 cm -> catégorie grande ouverture est gérée à l'ajout au panier dans pickVariant.)

    if (forme === "Cintré" && h2 > 0 && h2 >= h) {
      msgs.push(MKC.vMsg("arch"));
      fields.push("hauteur_2");
    }
    if (forme === "Asymétrique") {
      if (l2 < 0) {
        msgs.push(MKC.vMsg("asym"));
        fields.push("largeur_2");
      }
      if (h2 < 0) {
        msgs.push(MKC.vMsg("asym"));
        fields.push("hauteur_2");
      }
    }

    return {
      ok: msgs.length === 0,
      empty: false,
      messages: msgs,
      fields: fields,
    };
  };

  MKC.showDimValidation = function (result) {
    var root = MKC.getRoot();
    if (!root) return result;

    var errEl = MKC.q("[data-dim-err]");
    var dimInputs = MKC.qa(
      '[name="width"],[name="height"],[name="hauteur_2"],[name="largeur_2"],[name="segments"]',
    );

    dimInputs.forEach(function (inp) {
      inp.classList.remove("is-invalid");
      inp.removeAttribute("aria-invalid");
    });

    if (!result || result.empty) {
      if (errEl) {
        errEl.textContent = "";
        errEl.classList.remove("is-visible");
      }
      MKC.state.dimsValid = false;
      return result;
    }

    if (result.ok) {
      if (errEl) {
        errEl.textContent = "";
        errEl.classList.remove("is-visible");
      }
      MKC.state.dimsValid = true;
      return result;
    }

    if (errEl) {
      errEl.textContent = result.messages.join(" ");
      errEl.classList.add("is-visible");
    }

    (result.fields || []).forEach(function (name) {
      var inp = root.querySelector('[name="' + name + '"]');
      if (inp) {
        inp.classList.add("is-invalid");
        inp.setAttribute("aria-invalid", "true");
      }
    });

    MKC.state.dimsValid = false;
    return result;
  };

  /* ---- Unified update pipeline (registered by liquid inline scripts) ---- */
  MKC._hooks = { update: [], fast: [] };

  MKC.onUpdate = function (fn) {
    if (typeof fn === "function") MKC._hooks.update.push(fn);
  };

  MKC.onFastUpdate = function (fn) {
    if (typeof fn === "function") MKC._hooks.fast.push(fn);
  };

  MKC.runUpdate = function () {
    MKC.schedule(function () {
      var i;
      var validation = MKC.validateDimensions();
      MKC.showDimValidation(validation);
      for (i = 0; i < MKC._hooks.update.length; i++) {
        try {
          MKC._hooks.update[i](validation);
        } catch (e) {
          /* keep configurator alive */
        }
      }
    });
  };

  MKC.runFastUpdate = function () {
    MKC.debounce(
      "fast",
      function () {
        MKC.schedule(function () {
          var i;
          for (i = 0; i < MKC._hooks.fast.length; i++) {
            try {
              MKC._hooks.fast[i]();
            } catch (e) {
              /* noop */
            }
          }
        });
      },
      120,
    );
  };

  MKC.bindEvents = function () {
    var root = MKC.getRoot();
    if (!root || root._mkcBound) return;
    root._mkcBound = true;

    root.addEventListener("change", MKC.runUpdate);
    root.addEventListener("input", MKC.runFastUpdate);

    /* Delegated remove for cart lines — no re-bind on each render */
    var linesWrap = MKC.q("[data-lines]");
    if (linesWrap && !linesWrap._mkcRmBound) {
      linesWrap._mkcRmBound = true;
      linesWrap.addEventListener("click", function (e) {
        var rm = e.target.closest("[data-rm]");
        if (!rm || typeof MKC.removeLine !== "function") return;
        MKC.removeLine(parseInt(rm.getAttribute("data-rm"), 10));
      });
    }
  };

  MKC.init = function () {
    MKC.bindEvents();
    MKC.runUpdate();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", MKC.init);
  } else {
    MKC.init();
  }

  global.MKC = MKC;
})(typeof window !== "undefined" ? window : this);

/**
 * MOSKERA — Mode impérial (marchés US et CA, prefixes /en-us/ et /en-ca/).
 * Le client saisit des POUCES dans des champs proxy ; les vrais champs
 * restent en CM pour tout le moteur (prix, validation, panier, atelier).
 * 1 in = 2,54 cm, arrondi au dixieme des deux cotes. Un lien sous les
 * dimensions permet de repasser en cm.
 */
(function (global) {
  "use strict";

  /* CA ajoute le 09/09/2026 : au Canada les ouvertures se mesurent couramment
     en pouces. Le lien « switch to cm » reste disponible sous les champs. */
  var IMP = { on: /^\/en-(us|ca)(\/|$)/.test(location.pathname), unit: "in" };
  global.MKimp = IMP;
  IMP.active = function () {
    return IMP.on && IMP.unit === "in";
  };

  function fmt(n) {
    var v = Math.round(n * 10) / 10;
    return String(v).replace(/\.0$/, "");
  }
  function toCm(inch) {
    return Math.round(inch * 2.54 * 10) / 10;
  }
  function toIn(cm) {
    return Math.round((cm / 2.54) * 10) / 10;
  }

  /* Convertit une chaine d'affichage en cm ("92.7 × 233.7 cm") en pouces.
     Seuls les nombres AVANT le mot "cm" changent, et jamais ceux colles a
     une lettre (L1, H2 : indices de libelles, pas des mesures). Le reste
     de la chaine ("— 6 cotes") est conserve tel quel. */
  global.MKcv = function (s) {
    if (!IMP.active() || !s) return s;
    s = String(s);
    var m = s.match(/\bcm\b/);
    if (!m) return s;
    var cut = m.index + 2;
    var head = s.slice(0, cut);
    var tail = s.slice(cut);
    head = head.replace(/([A-Za-z])?(\d+(?:[.,]\d+)?)/g, function (all, pre, n) {
      if (pre) return all;
      return fmt(parseFloat(n.replace(",", ".")) / 2.54);
    });
    head = head.replace(/\s*\bcm\b/, " in");
    return head + tail;
  };

  /* Affichage double : pouces d'abord, equivalent cm entre parentheses
     (le client saisit des pouces mais l'atelier travaille en cm). */
  global.MKdual = function (s) {
    if (!IMP.active() || !s) return s;
    var c = global.MKcv(s);
    return c === s ? s : c + " (" + s + ")";
  };

  /* Annotations du schema 3D : un nombre en cm -> "36.5″" ou "92 cm". */
  global.MKpv = function (n) {
    if (!IMP.active()) return Math.round(n) + " cm";
    return fmt(n / 2.54) + "″";
  };

  /* Ligne dimensions sous le schema : rebatie depuis les valeurs cm NON
     arrondies (convertir "93 cm" deja arrondi donnerait 36.6 au lieu de
     36.5). Renvoie '' hors mode pouces, l'appelant garde alors sa chaine cm. */
  global.MKdsImp = function (forme, w, h, l2, h2) {
    if (!IMP.active()) return "";
    var f = function (n) {
      return fmt(n / 2.54);
    };
    if (forme === "Asymétrique")
      return "L1 " + f(w) + (l2 > 0 ? " / L2 " + f(l2) : "") + " × H1 " + f(h) + " / H2 " + f(h2 > 0 ? h2 : h) + " in";
    if (forme === "Cintré") return f(w) + " × H1 " + f(h) + (h2 > 0 ? " / H2 " + f(h2) : "") + " in";
    return f(w) + " × " + f(h) + " in";
  };

  if (!IMP.on) return;

  var DIMS = /^(width|height|largeur_2|hauteur_2|panneau_\d+)$/;
  var PH = { width: "e.g. 36.5″", height: "e.g. 92″", hauteur_2: "e.g. 79″", panneau: "e.g. 18″" };

  /* Masquage par deport hors ecran, PAS display:none : ready() ignore les
     champs dont offsetParent est null, il doit continuer a exiger les pans. */
  var css = document.createElement("style");
  css.textContent =
    ".mkc-imp-real{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;}" +
    ".mkc__unitTog{font-size:12.5px;color:#666;margin:2px 0 10px;}" +
    ".mkc__unitTog a{color:#b70f0f;text-decoration:underline;cursor:pointer;}";
  document.head.appendChild(css);

  var pairs = [];

  function push(px, evType) {
    var r = px._mkImpReal;
    if (!r) return;
    var v = parseFloat(String(px.value).replace(",", "."));
    r.value = isFinite(v) && v > 0 ? String(toCm(v)) : "";
    try {
      r.dispatchEvent(new Event(evType, { bubbles: true }));
    } catch (e) {}
  }

  function wire(inp) {
    if (inp._mkImpProxy || inp._mkImpReal || !DIMS.test(inp.name || "")) return;
    var px = document.createElement("input");
    px.type = "number";
    px.step = "0.1";
    px.min = "0";
    /* pas de name (le moteur lit [name=...]) ni .mkc-pan (idem par classe) */
    px.className =
      inp.className.replace(/\bis-invalid\b/g, "").replace(/\bmkc-pan\b/g, "").replace(/\s+/g, " ").trim() +
      " mkc-imp-proxy";
    var key = /^panneau_/.test(inp.name) ? "panneau" : inp.name;
    px.placeholder = PH[key] != null ? PH[key] : inp.placeholder || "";
    if (inp.value && isFinite(parseFloat(inp.value))) px.value = fmt(toIn(parseFloat(inp.value)));
    inp.parentNode.insertBefore(px, inp.nextSibling);
    inp.classList.add("mkc-imp-real");
    inp._mkImpProxy = px;
    px._mkImpReal = inp;
    px.addEventListener("input", function () {
      push(px, "input");
    });
    px.addEventListener("change", function () {
      push(px, "change");
    });
    pairs.push({ r: inp, p: px });
  }

  function unwire() {
    pairs.forEach(function (o) {
      o.r.classList.remove("mkc-imp-real");
      o.r._mkImpProxy = null;
      if (o.p.parentNode) o.p.parentNode.removeChild(o.p);
    });
    pairs = [];
  }

  function labels(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll(".mkc__label"), function (l) {
      if (IMP.active()) {
        if (l.innerHTML.indexOf("(cm)") >= 0) l.innerHTML = l.innerHTML.split("(cm)").join("(in)");
      } else if (l.innerHTML.indexOf("(in)") >= 0) {
        l.innerHTML = l.innerHTML.split("(in)").join("(cm)");
      }
    });
  }

  /* Resynchronise apres chaque cycle moteur : champs crees dynamiquement
     (cintre, asymetrique, pans), valeurs remises par le code (reset apres
     "Valider cette moustiquaire", circulaire qui copie la largeur), etat
     d'erreur a refleter sur le proxy visible. */
  /* Le moteur n'est pas toujours pret au chargement : sans ce repli, sync()
     sortait avant labels() et le champ restait titre « (cm) » alors que la
     saisie etait deja en pouces. */
  function R() {
    return (global.MKC && global.MKC.getRoot && global.MKC.getRoot()) || document.querySelector(".mkc__wrap");
  }

  function sync() {
    var root = R();
    if (!IMP.active() || !root) return;
    pairs = pairs.filter(function (o) {
      return o.r.isConnected;
    });
    Array.prototype.forEach.call(root.querySelectorAll('input[type="number"]'), wire);
    pairs.forEach(function (o) {
      o.p.classList.toggle("is-invalid", o.r.classList.contains("is-invalid"));
      if (document.activeElement === o.p) return;
      var rv = parseFloat(o.r.value);
      if (!o.r.value || !isFinite(rv)) {
        if (o.p.value !== "") o.p.value = "";
        return;
      }
      var pv = parseFloat(String(o.p.value).replace(",", "."));
      if (!isFinite(pv) || Math.abs(toCm(pv) - rv) > 0.05) o.p.value = fmt(toIn(rv));
    });
    labels(root);
  }

  function ensureToggle() {
    var root = R();
    if (!root || document.getElementById("mkcUnitTog")) return;
    var w = root.querySelector('[name="width"]');
    var row = w && w.closest(".mkc__row");
    if (!row || !row.parentNode) return;
    var d = document.createElement("div");
    d.id = "mkcUnitTog";
    d.className = "mkc__unitTog";
    row.parentNode.insertBefore(d, row);
    var render = function () {
      d.innerHTML =
        IMP.unit === "in"
          ? 'Measurements in <b>inches</b> · <a data-sw="cm">switch to cm</a>'
          : 'Measurements in <b>cm</b> · <a data-sw="in">switch to inches</a>';
    };
    render();
    d.addEventListener("click", function (e) {
      var a = e.target.closest("[data-sw]");
      if (!a) return;
      IMP.unit = a.getAttribute("data-sw");
      if (IMP.unit === "cm") {
        unwire();
        labels(root);
      } else {
        sync();
      }
      render();
      if (global.MKC && global.MKC.runUpdate) global.MKC.runUpdate();
    });
  }

  function tick() {
    ensureToggle();
    sync();
  }

  var hooked = false;
  function hook() {
    if (hooked || !global.MKC || !global.MKC.onUpdate) return;
    hooked = true;
    global.MKC.onUpdate(tick);
    global.MKC.onFastUpdate(tick);
  }
  function init() {
    hook();
    tick();
    /* Le moteur peut se declarer apres nous : on retente ~6 s, puis on s'arrete
       des que la bascule et les proxys sont en place. */
    var n = 0;
    var t = setInterval(function () {
      n++;
      hook();
      tick();
      if ((hooked && pairs.length && document.getElementById("mkcUnitTog")) || n > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(typeof window !== "undefined" ? window : this);
